module.exports = __webpack_public_path__ + "img/umajo@2x.749c6e5c.png";